import styled from 'styled-components'
import { colors, theme } from '../theme/Global'

export const CustomFullPageWrapper = styled.div`
  background-color: ${theme.colors.blueBackground};
  bottom: 0;
  height: 100%;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  flex: 1;
`

export const CustomPaperStyle = {
  background: colors.white,
  color: theme.colors.text,
  margin: '5vh auto 0 auto',
  maxWidth: '587px',
  padding: '59px 89px',
  textAlign: 'center',
  width: '90%'
}
